/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 15V2M12 2L8 6M12 2L16 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 10H7.5V10C6.10444 10 5.40666 10 4.83886 10.1722C3.56046 10.56 2.56004 11.5605 2.17224 12.8389C2 13.4067 2 14.1044 2 15.5V16C2 17.8638 2 18.7956 2.30448 19.5307C2.71046 20.5108 3.48915 21.2895 4.46927 21.6955C5.20435 22 6.13623 22 8 22L16 22C17.8638 22 18.7956 22 19.5307 21.6955C20.5108 21.2895 21.2895 20.5108 21.6955 19.5307C22 18.7956 22 17.8638 22 16V15.5C22 14.1044 22 13.4067 21.8278 12.8389C21.44 11.5605 20.4395 10.56 19.1611 10.1722C18.5933 10 17.8956 10 16.5 10V10H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="10"
				width="20"
				height="12"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M8 10L7.5 10V10C6.10444 10 5.40666 10 4.83886 10.1722C3.56046 10.56 2.56004 11.5605 2.17224 12.8389C2 13.4067 2 14.1044 2 15.5V16C2 17.8638 2 18.7956 2.30448 19.5307C2.71046 20.5108 3.48915 21.2895 4.46927 21.6955C5.20435 22 6.13623 22 8 22L16 22C17.8638 22 18.7956 22 19.5307 21.6955C20.5108 21.2895 21.2895 20.5108 21.6955 19.5307C22 18.7956 22 17.8638 22 16V15.5C22 14.1044 22 13.4067 21.8278 12.8389C21.44 11.5605 20.4395 10.56 19.1611 10.1722C18.5933 10 17.8956 10 16.5 10V10H16M12 15L12 2M12 2L8 6M12 2L16 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.5303 1.46967C12.2374 1.17678 11.7626 1.17678 11.4697 1.46967L7.46967 5.46967C7.17678 5.76256 7.17678 6.23744 7.46967 6.53033C7.76256 6.82322 8.23744 6.82322 8.53033 6.53033L11.25 3.81066L11.25 9.25H7.65C5.40979 9.25 4.28968 9.25 3.43404 9.68597C2.68139 10.0695 2.06947 10.6814 1.68597 11.434C1.25 12.2897 1.25 13.4098 1.25 15.65L1.25 16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28968 22.75 5.40979 22.75 7.65 22.75L16.35 22.75C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V15.65C22.75 13.4098 22.75 12.2897 22.314 11.434C21.9305 10.6814 21.3186 10.0695 20.566 9.68597C19.7103 9.25 18.5902 9.25 16.35 9.25H12.75L12.75 3.81066L15.4697 6.53033C15.7626 6.82322 16.2374 6.82322 16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L12.5303 1.46967ZM12.75 9.25H11.25V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V9.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 10L16.5 10V10C17.8956 10 18.5933 10 19.1611 10.1722C20.4395 10.56 21.44 11.5605 21.8278 12.8389C22 13.4067 22 14.1044 22 15.5V16C22 17.8638 22 18.7956 21.6955 19.5307C21.2895 20.5108 20.5108 21.2895 19.5307 21.6955C18.7956 22 17.8638 22 16 22L14.5 22H14M8 10H7.5V10C6.10444 10 5.40666 10 4.83886 10.1722C3.56046 10.56 2.56004 11.5605 2.17224 12.8389C2 13.4067 2 14.1044 2 15.5L2 16C2 17.8638 2 18.7956 2.30448 19.5307C2.71046 20.5108 3.48915 21.2895 4.46927 21.6955C5.20435 22 6.13623 22 8 22L9.5 22H10M12 15L12 2L8 6M14.5 4.5L16 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 10H7.5V10C6.10444 10 5.40666 10 4.83886 10.1722C3.56046 10.56 2.56004 11.5605 2.17224 12.8389C2 13.4067 2 14.1044 2 15.5V16C2 17.8638 2 18.7956 2.30448 19.5307C2.71046 20.5108 3.48915 21.2895 4.46927 21.6955C5.20435 22 6.13623 22 8 22L16 22C17.8638 22 18.7956 22 19.5307 21.6955C20.5108 21.2895 21.2895 20.5108 21.6955 19.5307C22 18.7956 22 17.8638 22 16V15.5C22 14.1044 22 13.4067 21.8278 12.8389C21.44 11.5605 20.4395 10.56 19.1611 10.1722C18.5933 10 17.8956 10 16.5 10V10H16M12 15V2M12 2L8 6M12 2L16 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.65 9.25C5.40979 9.25 4.28969 9.25 3.43404 9.68597C2.68139 10.0695 2.06947 10.6814 1.68597 11.434C1.25 12.2897 1.25 13.4098 1.25 15.65V16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28969 22.75 5.40979 22.75 7.65 22.75H16.35C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V15.65C22.75 13.4098 22.75 12.2897 22.314 11.434C21.9305 10.6814 21.3186 10.0695 20.566 9.68597C19.7103 9.25 18.5902 9.25 16.35 9.25H7.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4697 1.46967C11.7626 1.17678 12.2374 1.17678 12.5303 1.46967L16.5303 5.46967C16.8232 5.76256 16.8232 6.23744 16.5303 6.53033C16.2374 6.82322 15.7626 6.82322 15.4697 6.53033L12.75 3.81066L12.75 16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16L11.25 3.81066L8.53033 6.53033C8.23744 6.82322 7.76256 6.82322 7.46967 6.53033C7.17678 6.23744 7.17678 5.76256 7.46967 5.46967L11.4697 1.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
